<template>
  <article id="nosotros">
    
    <div class="container row">
        <div class="one-half column">
            <h1>NOSOTROS</h1>
            Las balanza cumplen un rol muy importante en el proceso
            productivo de toda empresa. Siendo tambien el principal
            punto de control del ingreso y egreso de mercaderias.
            STBalanzas es una Empresa con trayectoria en la industria del
            pesaje. Estamos enfocados en ofrecer soluciones eficientes a
            nuestros clientes, optimizando los tiempos de trabajo y
            usando los más altos estándares de calidad y seguridad.
            <h3> A QUE NOS DEDICAMOS:</h3>
            Brindamos asesoramiento, a las empresas que necesitan
            contar con un sistema de pesaje fiable.
            Nos especializamos en basculas de camiones y trenes,
            balanzas de tipo industrial y servicios relacionados.
            <h3>DONDE ESTAMOS:</h3>
            Contamos con bases operativas en Cuyo, y Region
            Metropolitana pudiendo brindar asesoramiento en toda la
            Republica Argentina y Chile
        </div>
        <div class="one-half column">
            <img src="/img/nosotros.jpg" style=" height: auto;width: 100%;">
        </div>
    </div>
  </article>
</template>

<script>
export default {
  
  
}
</script>


<style>
  #nosotros{
    background-color: #478CCF;
    color: #FEFEFE;
    padding-top: 100px;
    padding-bottom: 100px;
  }
  
</style>
